// extracted by mini-css-extract-plugin
export var Interests = "style-module--Interests--1II-J";
export var Interest = "style-module--Interest--3ukRb";
export var Icon = "style-module--Icon--2gZDV";